export default {
  state: {
    navList: [
      {
        className: 'el-icon-location',
        title: '商品类目管理',
        json: [
          { name: '商品分类', path: '/goodsClass' },
          { name: '商品属性', path: '/goodsAttr' },
        ],
      },
      { className: 'el-icon-menu', title: '盘数账户管理', json: [{ name: '账户管理', path: '/accountManage' }] },
      {
        className: 'el-icon-document',
        title: '磐石权限管理',
        json: [
          { name: '访问权限', path: '/permissionsAccess' },
          { name: '数据权限', path: '/permissionsData' },
        ],
      },
      {
        className: 'el-icon-setting',
        title: '系统设置',
        json: [
          { name: '系统账号', path: '/systemAccount' },
          { name: '系统角色', path: '/systemRole' },
          { name: '访问权限', path: '/systemPermissionsAccess' },
          { name: '数据权限', path: '/systemPermissionsData' },
        ],
      },
    ],
  },
}
